export default __webpack_public_path__ + "static/media/workflow_missed.d8d406f5.svg";